
<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'KeyDates',

    metaInfo: { title: 'Key Dates' },

    extends: View,

    mixins: [
      LoadSections([
        'key-dates',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'key-dates',
      },
    },
  }
</script>
